import { render, staticRenderFns } from "./PopReadAgreement.vue?vue&type=template&id=2102d5e4&lang=pug"
import script from "./PopReadAgreement.vue?vue&type=script&lang=js"
export * from "./PopReadAgreement.vue?vue&type=script&lang=js"
import style0 from "./PopReadAgreement.vue?vue&type=style&index=0&id=2102d5e4&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports